const APP_NAMES = {
  PARTNER: 'partner',
  CUSTOMER: 'customer',
  EMPLOYEE: 'employee',
}

export { APP_NAMES };
